import { useCallback, useEffect, useState } from "react";
import { styled } from "@linaria/react";
import { css } from "@linaria/core";
const hasCursor = typeof window !== "undefined" && window.matchMedia("(any-pointer: fine)").matches;
const CopyCodeWrapper = /*#__PURE__*/styled("span")({
  name: "CopyCodeWrapper",
  class: "c10krhzi",
  vars: {
    "c10krhzi-0": [({
      copied
    }) => copied ? "var(--color-green)" : "var(--color-gray-dark)"],
    "c10krhzi-1": [({
      copied
    }) => copied ? "var(--color-white)" : "var(--color-gray-light)"],
    "c10krhzi-2": [({
      copied
    }) => copied ? "var(--color-green)" : "var(--color-gray-dark)"]
  }
});
const hoverClass = "hx9tfyy";

const CopyCode = ({
  codeSnippet,
  hovered
}: {
  codeSnippet: string;
  hovered: boolean | undefined;
}): JSX.Element => {
  const [isCopied, setIsCopied] = useState(false);
  const [copyText, setCopyText] = useState<"Copy" | "Copied">("Copy");
  useEffect(() => {
    let timeout: ReturnType<typeof setTimeout> | undefined;

    if (isCopied && !timeout) {
      timeout = setTimeout(() => {
        setIsCopied(false);

        if (hovered || !hasCursor) {
          setCopyText("Copy");
        }
      }, 3000);
    }

    return () => {
      if (timeout) {
        clearTimeout(timeout);
      }
    };
  }, [hovered, isCopied]);
  const copyToClipboard = useCallback(() => {
    navigator.clipboard.writeText(codeSnippet).then(() => {
      setIsCopied(true);
      setCopyText("Copied");
    });
  }, [codeSnippet]); // Event listener to change text after transition preventing content flash

  const onTransitionEnd = useCallback(() => {
    if (!isCopied && !hovered && hasCursor) {
      setCopyText("Copy");
    }
  }, [hovered, isCopied]);
  return <CopyCodeWrapper className={hovered || isCopied ? hoverClass : undefined} copied={isCopied} onClick={copyToClipboard} onTransitionEnd={onTransitionEnd}>
      {copyText}
    </CopyCodeWrapper>;
};

export default CopyCode;

require("../../../.linaria-cache/src/components/Code/CopyCode.linaria.module.css");